class MobileSearchSeparate extends SearchForm {
  constructor() {
    super();
    this.mobileInput = this.querySelector('#Search-Mobile');
    this.resetButton = this.querySelector('.mobile-search-reset');
    this.setupMobileSearch();
  }

  setupMobileSearch() {
    if (!this.mobileInput) return;
    
    // Sync mobile search with other search inputs
    this.mobileInput.addEventListener('input', (event) => {
      this.syncSearchInputs(event.target.value);
      this.toggleResetButton();
    });

    // Handle mobile search focus
    this.mobileInput.addEventListener('focus', () => {
      this.mobileInput.parentElement.classList.add('focused');
    });

    this.mobileInput.addEventListener('blur', () => {
      setTimeout(() => {
        this.mobileInput.parentElement.classList.remove('focused');
      }, 150);
    });

    // Handle reset button
    if (this.resetButton) {
      this.resetButton.addEventListener('click', () => {
        this.mobileInput.value = '';
        this.syncSearchInputs('');
        this.toggleResetButton();
        this.mobileInput.focus();
      });
    }
  }

  syncSearchInputs(value) {
    const allSearchInputs = document.querySelectorAll('input[type="search"]');
    allSearchInputs.forEach(input => {
      if (input !== this.mobileInput) {
        input.value = value;
      }
    });
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    
    if (this.mobileInput.value.length > 0) {
      this.resetButton.classList.remove('hidden');
    } else {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }
}

// Handle mobile search positioning with sticky header
class MobileSearchPositioning {
  constructor() {
    this.mobileSearchContainer = document.querySelector('.mobile-search-container');
    this.headerGroup = document.querySelector('.shopify-section-group-header-group');
    this.init();
  }

  init() {
    if (!this.mobileSearchContainer || window.innerWidth > 989) return;
    
    // Watch for sticky header changes
    const headerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          this.updateMobileSearchPosition();
        }
      });
    });

    // Watch for mobile search visibility changes
    const searchObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          this.updateBodyPadding();
        }
      });
    });

    if (this.headerGroup) {
      headerObserver.observe(this.headerGroup, { attributes: true });
    }

    searchObserver.observe(this.mobileSearchContainer, { attributes: true });

    // Initial positioning
    this.updateMobileSearchPosition();
    this.updateBodyPadding();
  }

  updateBodyPadding() {
    // Remove body padding as it creates white space issues
    // The sticky header positioning handles this naturally
    return;
  }

  updateMobileSearchPosition() {
    // Keep positioning simple to avoid white space conflicts
    // Let CSS handle the positioning naturally
    return;
  }
}

// Initialize mobile search when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  const mobileSearchElements = document.querySelectorAll('.mobile-search-wrapper');
  mobileSearchElements.forEach(element => {
    if (!customElements.get('mobile-search-separate')) {
      customElements.define('mobile-search-separate', MobileSearchSeparate);
    }
  });

  // Initialize mobile search positioning
  new MobileSearchPositioning();
});

// Handle mobile search predictive search positioning
class MobilePredictiveSearchSeparate extends PredictiveSearch {
  constructor() {
    super();
    this.setupMobilePositioning();
  }

  setupMobilePositioning() {
    if (window.innerWidth <= 989) {
      this.addEventListener('open', () => {
        this.adjustMobilePosition();
      });
    }
  }

  adjustMobilePosition() {
    const results = this.querySelector('.predictive-search--mobile-separate');
    if (results) {
      const searchField = this.querySelector('.mobile-search-field');
      if (searchField) {
        const rect = searchField.getBoundingClientRect();
        results.style.width = `${rect.width}px`;
      }
    }
  }
}

// Register mobile predictive search if predictive search is enabled
if (typeof PredictiveSearch !== 'undefined') {
  customElements.define('mobile-predictive-search-separate', MobilePredictiveSearchSeparate);
}

// Handle Mobile Floating Search Icon Visibility
class MobileFloatingSearchIcon {
  constructor() {
    this.floatingIcon = document.querySelector('.mobile-floating-search-icon');
    this.mobileSearchContainer = document.querySelector('.mobile-search-container');
    this.scrollThreshold = 150; // Show icon after scrolling 150px
    this.lastScrollTop = 0;
    
    if (this.floatingIcon && window.innerWidth <= 989) {
      this.init();
    }
  }

  init() {
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    window.addEventListener('resize', this.handleResize.bind(this));
    
    // Initial check
    this.handleScroll();
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Show floating icon when scrolled past threshold
    if (scrollTop > this.scrollThreshold) {
      this.floatingIcon.classList.add('visible');
    } else {
      this.floatingIcon.classList.remove('visible');
    }
    
    this.lastScrollTop = scrollTop;
  }

  handleResize() {
    // Hide on desktop
    if (window.innerWidth > 989) {
      this.floatingIcon.classList.remove('visible');
    } else {
      // Re-check scroll position on resize to mobile
      this.handleScroll();
    }
  }
}

// Initialize floating search icon
document.addEventListener('DOMContentLoaded', () => {
  new MobileFloatingSearchIcon();
});
